<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }"> {{ text }} </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import IDFilter from "../../filterImplementations/IDFilter";
import FilterBadge from "./FilterBadge.vue";
import { FilterBadgeProps } from "../../FilterTypes";
import { useSQDCDisplayName } from "../../../../../helper/SQDCDisplayNameHelper";

const props = defineProps({
  filter: {
    type: Object as PropType<IDFilter>,
    required: true,
  },
  ...FilterBadgeProps,
});
const { t } = useTranslation();
const displayName = useSQDCDisplayName();

const typeNames = computed(
  () => new Map(props.types.map((type) => [type.id.toString(), displayName(type)])),
);
const sortedIDs = computed(() => [...props.filter.ids].sort((left, right) => right - left));

function getTypeFieldName() {
  const name =
    props.filter.typeId == null ? undefined : typeNames.value.get(props.filter.typeId.toString());

  return name ?? t("global.na");
}

const text = computed(() => {
  const typeText = props.filter.typeId ? getTypeFieldName() : t(`global.all`);
  return `${typeText}${sortedIDs.value.length > 0 ? " | " : ""}${sortedIDs.value.join(", ")}`;
});
</script>

<style lang="scss" scoped></style>
